import { SlideshowEnginePort } from '@vp/slideshow/core/interface/SlideshowEnginePort';

export abstract class SlideshowEngineFactoryPort {
  abstract create(slidesCount: number, slideTime: number): SlideshowEnginePort;
}
